module.exports = __webpack_public_path__ + "img/victrix-bretelle-1.c86c71d6.jpg";